<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0">
        <v-row>
          <v-col cols="6" class="py-0 ma-0">
            <span class="text-label">Dados do cliente:</span>
          </v-col>
          <v-col
            v-if="$user.roles === 'Multiplo.Master'"
            cols="6"
            class="py-0 ma-0 text-right"
          >
            <v-btn @click="openAnaliseCredito" color="primary"
              >Revisar análise de crédito</v-btn
            >
          </v-col>

          <v-col cols="4" class="py-0 ma-0">
            <span>Documento Federal</span>
          </v-col>
          <v-col cols="8" class="py-0 ma-0">
            <span>{{
              model.Cliente.TipoPessoa === $aux.TipoPessoaEnum.PF
                ? "Nome"
                : "Razão Social"
            }}</span>
          </v-col>
          <v-col cols="4" class="py-0 ma-0">
            {{ model.Cliente.DocumentoFederal }}
          </v-col>
          <v-col cols="8" class="py-0 ma-0">
            {{ model.Cliente.Nome }}
          </v-col>
          <v-col cols="12" class="pb-0 ma-0">
            <span class="text-label">Operação de crédito:</span>
          </v-col>
          <v-col cols="4" class="py-0 ma-0">
            <span>Tipo de Operação: {{ model.TipoOperacaoDescricao }}</span>
          </v-col>
          <v-col cols="8" class="py-0 ma-0">
            <span>Produto: {{ model.TipoContratoDescricao }}</span>
          </v-col>
          <v-col cols="12" class="pb-0 ma-0">
            <span class="text-label">Dados da Operação de crédito:</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span class="text-value-label">Valor Líquido Solicitado: </span>
            <span class="text-value">{{
              $api.UI.Format.Currency(model.VlrSolicitado)
            }}</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span>Cliente é produtor rural?</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span class="text-value-label">Valor Total Solicitado: </span>
            <span class="text-value">{{
              $api.UI.Format.Currency(model.VlrSolicitado)
            }}</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span>{{ model.isProdutorRural ? "Sim" : "Não" }}</span>
          </v-col>
          <v-col cols="12" class="py-0 ma-0">
            <span>IOF: {{ $api.UI.Format.Currency(model.VlrIOF) }}</span>
          </v-col>
          <v-col cols="12" class="py-0 ma-0">
            <span>TAC: {{ $api.UI.Format.Currency(model.VlrTAC) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label"
              >Valor Total Financiado:
              {{ $api.UI.Format.Currency(model.VlrTotalCredito) }}</span
            >
          </v-col>
          <v-col cols="6">
            <span class="text-label"
              >Prestações:
              {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }} até
              {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}</span
            >
          </v-col>

          <v-col cols="6" class="py-0">
            <span class="text-label"
              >Número de Prestações: {{ model.Prazo }}</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >Valor da Prestação:
              {{ $api.UI.Format.Currency(model.VlrParcela) }}</span
            >
          </v-col>

          <v-col cols="6" class="py-0 ma-0">
            <span
              >Taxa de Juros:
              {{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% a.m.</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >CET: {{ $api.UI.Format.Decimal(model.PercCETMensal) }}% a.m.
              {{ $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span class="text-value-label"
              >Amortização:
              {{
                model.ModeloCalculo === $api.BancoApia.ModeloCalculoEnum.Price
                  ? "Price"
                  : "SAC"
              }}</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span class="text-value"
              >Modalidade: Pré-Fixado
            </span>
          </v-col>
          <v-col cols="12" class="pb-0 ma-0">
            <span class="text-label">Prestações:</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span>1ª prestação</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span>Última prestação</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >Data:
              {{
                $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento)
              }}</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >Data:
              {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >Valor:
              {{
                $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal)
              }}</span
            >
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span
              >Valor:
              {{
                $api.UI.Format.Currency(model.UltimaParcela.VlrPrestacaoTotal)
              }}</span
            >
          </v-col>
          <v-col cols="12" class="pb-0 ma-0">
            <span class="text-label">Valor Total da Dívida</span>
          </v-col>
          <v-col cols="6" class="py-0 ma-0">
            <span> {{ $api.UI.Format.Currency(model.VlrTotalDivida) }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0 mt-6">
            <span class="text-h5 text-center">Fluxo de Pagamento</span>
          </v-col>
          <v-col cols="12" class="px-2 pt-0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Parcela</th>
                    <th class="text-center">Vencimento</th>
                    <th class="text-right">Prestação</th>
                    <!--<th class="text-right"> Amortização </th>
                    <th class="text-right"> Juros </th>-->
                    <th class="text-right">Saldo Devedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.Parcelas.length === 0">
                    <td colspan="7" class="text-center text--disabled">
                      Aguardando geração das parcelas
                    </td>
                  </tr>
                  <tr v-for="(item, index) in model.Parcelas" :key="index">
                    <template v-if="index < 3 || verTodasParcelas">
                      <td class="text-center">
                        {{ (item.NumeroParcela || index) + 1 }}
                      </td>
                      <td class="text-center">
                        {{ $api.UI.Format.Date(item.DtVencimento) }}
                      </td>
                      <td class="text-right">
                        {{ $api.UI.Format.Currency(item.VlrPrestacaoTotal) }}
                      </td>
                      <!--<td class="text-right">{{ item.VlrAmortizacao !== null ? $api.UI.Format.Currency(item.VlrAmortizacao) : '-' }}</td>
                      <td class="text-right">{{ item.VlrJurosAcumulado !== null ? $api.UI.Format.Currency(item.VlrJurosAcumulado) : '-' }}</td>-->
                      <td class="text-right">
                        {{
                          item.VlrSaldoDevedor !== null
                            ? $api.UI.Format.Currency(item.VlrSaldoDevedor)
                            : "-"
                        }}
                      </td>
                    </template>
                    <td
                      role="button"
                      v-else-if="index === 3"
                      colspan="7"
                      class="text-center text-decoration-underline primary--text"
                      @click="verTodasParcelas = true"
                    >
                      ver todas as parcelas
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="resumoProposta && isLoaded">
          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos do Emitente</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" resumo :codigoProposta="model.Codigo" :codigoPessoa="model.CodigoCliente" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos da Proposta</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Proposta" resumo :codigoProposta="model.Codigo" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1"
                >Avalistas/Representantes legais</span
              >
            </v-col>
            <v-col cols="12">
              <PropostaAvalista :key="model.Codigo" resumo :value="model"></PropostaAvalista>
            </v-col>
            <!-- <input-select
              label="Tipo de CCB"
              v-model="tipoCCB"
              :options="tipoEmprestimo"
              required
            /> -->
          </v-row>
        </template>
      </v-col>
    </v-row>
    <PropostaResumoAnalise resumo ref="resumoAnalise" />
  </div>
</template>
<script>
export default {
  components: {
    PropostaAvalista: () => import('@/views/PropostaAvalista.vue'),
    PropostaResumoAnalise: () => import('@/views/PropostaResumoAnalise.vue'),
  },
  props: {
    resumoProposta: { type: Boolean, default: false },
  },
  data () {
    return {
      DtoConsultaMotor: null,
      model: {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {},
      },
      tipoEmprestimo: [
        { text: 'Cartular', value: 'C' },
        { text: 'Eletrônica', value: 'E' },
      ],
      isLoaded: false,
      verTodasParcelas: false,
    };
  },
  computed: {
    vlrTotalSolicitado () {
      return this.model.VlrSolicitado + (this.model.VlrIOF || 0) + (this.model.VlrTAC || 0);
    },
    tipoCCB: {
      get () {
        const th = this;
        var versaoCCB = Object.keys(th.$param.TipoContrato_CCB).find(
          (p) => th.$param.TipoContrato_CCB[p] === th.model.CodigoVersaoCCB
        );

        if (versaoCCB.split('_')[1] === 'E') {
          return 'E';
        } else {
          return 'C';
        }
      },
      set () {
        const th = this;
        const versaoCCB = th.getVersaoCCB();

        th.$api.Multiplo.SaveProposta({
          ...th.model,
          CodigoVersaoCCB: versaoCCB,
        }).then(function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            th.model.CodigoVersaoCCB = versaoCCB;
          }
        });
      },
    },
  },
  methods: {
    getVersaoCCB () {
      const th = this;
      const tipoContrato = th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PF ? 'CP' : 'CG';

      return th.$param.TipoContrato_CCB[`${tipoContrato}_${th.tipoCCB}`];
    },
    getTipoCCB (model) {
      const th = this;
      var versaoCCB = Object.keys(th.$param.TipoContrato_CCB).find(
        (p) => th.$param.TipoContrato_CCB[p] === model.CodigoVersaoCCB
      );

      if (versaoCCB.split('_')[1] === 'E') {
        return { text: 'Eletrônica', value: 'E' };
      } else {
        return { text: 'Cartular', value: 'C' };
      }
    },
    listPropostaCampoAuxiliar (codigoProposta) {
      const th = this;
      const dto = {
        parameters: [{ name: 'CodigoProposta', value: codigoProposta }],
      };

      th.$api.Multiplo.ListPropostaCampoAuxiliar(dto).then(
        (response) => {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (response.Data && response.Data.length > 0) {
              response.Data.forEach((item) => {
                if (item.NomeCampo === 'PROPOSTA_CONSULTAMOTOR') {
                  th.DtoConsultaMotor = JSON.parse(item.ValorCampo);
                }
                if (item.NomeCampo === 'PROPOSTA_PRODUTORRURAL') {
                  th.model.isProdutorRural = item.ValorCampo;
                }
              });
            }
          }
        }
      );
    },
    getInfoSocios (objeto) {
      return Object.keys(objeto)
        .filter(function (k) {
          return k.indexOf('socio') === 0;
        })
        .map(function (k) {
          return objeto[k];
        });
    },
    openAnaliseCredito () {
      const th = this;
      if (th.DtoConsultaMotor) {
        if (th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PF) {
          th.$api.BMPCred.NovaOperacaoUnica(th.DtoConsultaMotor, 'PF').then(
            (response) => {
              if (th.$api.UI.PostLoadData(response, true)) {
                const dadosLimite = {};
                if (response.tomadores) {
                  dadosLimite.Aprovacao = response.tomadores.find(
                    (p) => p.proposito === 'Aprovacao'
                  );
                  dadosLimite.Limite = response.tomadores.find(
                    (p) => p.proposito === 'Limite'
                  );
                  const resultMotor = {};
                  resultMotor.DadosLimite = dadosLimite;
                  th.$api.Bureau.validaBureaus(th, th.model.Cliente.DocumentoFederal, response.bureaus,
                    () => {
                      th.$refs.resumoAnalise.openModal({
                        Pessoa: th.model.Cliente,
                        PercJurosNegociado: th.model.PercJurosMensal,
                        ...th.model,
                        ...resultMotor,
                      });
                    })
                } else {
                  th.$api.UI.ShowError('Erro', response);
                }
              }
            }
          );
        } else {
          th.$api.BMPCred.NovaOperacaoUnica(th.DtoConsultaMotor, 'PJ').then(
            (response) => {
              if (th.$api.UI.PostLoadData(response, true)) {
                const dadosLimite = {};
                if (response.tomadores) {
                  dadosLimite.Aprovacao = response.tomadores.find(
                    (p) => p.proposito === 'Aprovacao'
                  );
                  dadosLimite.Limite = response.tomadores.find(
                    (p) => p.proposito === 'Limite'
                  );
                  const infoSocios = th.getInfoSocios(
                    response.bureaus.databusca
                  );
                  const resultMotor = {};
                  resultMotor.DadosLimite = dadosLimite;
                  resultMotor.DadosSocios = infoSocios;

                  th.$api.Bureau.validaBureaus(th, th.model.Cliente.DocumentoFederal, response.bureaus,
                    () => {
                      th.$refs.resumoAnalise.openModal({
                        ...th.model,
                        ...resultMotor,
                      });
                    })
                } else {
                  th.$api.UI.ShowError('Erro', response);
                }
              }
            }
          );
        }
      } else {
        th.$api.UI.ShowError('Erro', th.$getErrorMessage('motor').message);
      }
    },
    close () {
      this.$set(this, 'model', {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {}
      })
      this.isLoaded = false
    },
    load (model) {
      const th = this;

      const obj = {
        dto: {
          VlrSolicitado: model.VlrSolicitado,
          Prazo: model.Prazo,
          NroDiasAcrescimo: th.$api.BancoApia.CarregaDiasAcrescimo(th, model.DtPrimeiroVencto),
          PercJurosNegociado: model.PercJurosMensal,
          TipoPessoa: model.Cliente.TipoPessoa,
          VlrTAC: model.VlrTAC
        },
      };

      th.listPropostaCampoAuxiliar(model.Codigo);

      th.$api.Multiplo.CalculaGridParcelasSimplificadoPrice(obj).then(
        (result) => {
          if (th.$api.UI.PostLoadData(result, true)) {
            model = { ...model, ...result.Proposta };
            th.$api.UTIL.SetAllButNull(th, 'model', model);
            th.isLoaded = true;
          }
        }
      );
    },
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: bold;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
